// https://www.youtube.com/watch?v=YeSzQzfcQCs

<template>
  <div class="items-admin-page">
    <header class="items-admin-header">
      <div>
        <div class="items-admin-kicker">Inventory Control</div>
        <h1>{{ pageTitle }}</h1>
      </div>

      <div v-if="!showCategoryPicker" class="items-admin-status">
        <span class="items-admin-status-dot"></span>
        <span>{{ statusLabel }}</span>
      </div>
    </header>

    <section class="items-admin-panel" :class="{ 'items-admin-panel--library': showCategoryPicker }">
      <div v-if="!showCategoryPicker" class="items-admin-panel-topline"></div>

      <SelectCategory v-if="showCategoryPicker" />

      <div v-else class="items-admin-workspace">
        <div class="items-toolbar">
          <div class="items-toolbar-nav">
            <button
              v-if="$route.name == 'Items'"
              type="button"
              class="items-nav-button"
              @click="backToCategories()"
            >
              <span class="icon icon-reply"></span>
              <span>Back To Categories</span>
            </button>

            <router-link
              v-else
              class="items-nav-button"
              :to="'/users/items-controller/items?type=' + getType()"
            >
              <span class="icon icon-reply"></span>
              <span>Back To List</span>
            </router-link>

            <router-link
              v-if="$route.name !== 'Add Part' && $route.name !== 'Edit Part'"
              class="items-nav-button items-nav-button-primary"
              :to="'/users/items-controller/addpart?type=' + getType()"
            >
              <span class="icon icon-add-to-list"></span>
              <span>Add {{ currentTypeLabel }}</span>
            </router-link>
          </div>

          <div class="items-toolbar-meta">
            {{ currentTypeLabel }}
          </div>
        </div>

        <router-view></router-view>
      </div>
    </section>
  </div>
</template>

<script>
import { EventBus }       from '../../eventBus'
import { mapGetters, mapActions }     from 'vuex';
import SelectCategory     from './SelectCategory.vue'

export default {
  name: 'Items Controller',
  components:{
    SelectCategory,
  },
  watch: { 
    attribs: function() { // watch it
    },
    asin: function(newVal) { // watch it
    console.log(newVal)
    },
    '$route.query.type': function() {
      this.hydrateFromRoute()
    },
    '$route.query.showArchived': function() {
      this.hydrateFromRoute()
    },
  },
  data() {
    return {
      status: 'Paste a product link and press fetch to get started...',
      forms: {},
      autoFillMode: true,
      attribs: {
        general: {
        },
        specifications:[],
        compats: [],
      },
       categoryChosen: false,
       category: '',
       message: '',
    }
  },
  computed: {
    ...mapGetters([
        'getAttribs',
        'allProcessors',
        'allMotherboards',
        'allRam',
        'allStorage',
        'allGpus',
        'allPsus',
        'allCases',
        'allAccessories',
        'getCurrentPartType',
    ]),
    showCategoryPicker() {
      return this.$route.name == 'ItemsController' || this.$route.path == '/users/items-controller'
    },
    currentTypeLabel() {
      return this.formatPartType(this.getType() || this.getCurrentPartType || this.category || 'Parts')
    },
    pageTitle() {
      if (this.showCategoryPicker) {
        return 'All Parts'
      }

      if (this.$route.name == 'Edit Part') {
        return 'Edit ' + this.currentTypeLabel
      }

      if (this.$route.name == 'Add Part') {
        return 'Add ' + this.currentTypeLabel
      }

      return this.currentTypeLabel + ' Catalog'
    },
    statusLabel() {
      return this.showCategoryPicker ? 'Choose Category' : 'Catalog Manager'
    },
  },
  mounted() {
    this.hydrateFromRoute()
    EventBus.$on('chooseCategory', (category) => {
      this.fetchItems({ type: category, includeArchived: this.showArchivedEnabled() })
      this.categoryChosen = true;
      this.category = category.toLowerCase();
      switch(category.toLowerCase()) {
          case 'cpu':
              console.log('processors assigned')
              this.forms = this.allProcessors
          break;
          case 'motherboard':
              console.log('motherboards assigned')
              this.forms = this.allMotherboards
          break;
          case 'ram':
              console.log('RAM assigned')
              this.forms = this.allRam
          break;
          case 'storage':
              console.log('Storage assigned')
              this.forms = this.allStorage
          break;
          case 'graphics':
              console.log('Graphics assigned')
              this.forms = this.allGpus
          break;
          case 'psu':
              console.log('PSU assigned')
              this.forms = this.allPsus
          break;
          case 'case':
              console.log('Case assigned')
              this.forms = this.allCases
          break;
          case 'accessories':
              console.log('Accessories assigned')
              this.forms = this.allAccessories
          break;
          default:
      }
    });
  },
  methods: {
    ...mapActions([
      'setPartAttribs',
      'setCurrentPartType',
      'fetchItems',
      'unsetItem',
      'itemsLoaded'
    ]),
    hydrateFromRoute() {
      var type = this.getType()

      if (type) {
        this.categoryChosen = true
        this.category = type
        this.setCurrentPartType(type)
        this.setPartAttribs()

        if (this.$route.name == 'Items') {
          this.fetchItems({ type: type, includeArchived: this.showArchivedEnabled() })
        }
      }
      else if (this.showCategoryPicker) {
        this.categoryChosen = false
        this.category = ''
        this.itemsLoaded(false)
      }
    },
    backToCategories(){
      this.itemsLoaded(false)
      this.categoryChosen = false
      this.category = '';
      this.forms = {}
      this.unsetItem()
      this.$router.push('/users/items-controller').catch(()=>{})
    },
    autoFill(attribs, value){
      //General
      for(var i = 0; i<attribs.general.length; i++){
        attribs.general[i] = value;
      }
      //Specifications
      for(var j = 0; j<attribs.specifications.length; j++){
        attribs.specifications[j] = value;
      }
      //Compatibility
      for(var k = 0; k<attribs.compats.length; k++){
        attribs.compats[k] = value;
      }
      this.message = 'Auto Filled'
    },
    getType(){
      return this.$route.query.type
    },
    showArchivedEnabled(){
      var value = this.$route.query.showArchived
      return value === true || value === '1' || value === 'true' || value === 'yes'
    },
    formatPartType(type) {
      if (!type) {
        return 'Parts'
      }

      switch (type.toLowerCase()) {
        case 'cpu':
          return 'CPU'
        case 'gpu':
        case 'graphics':
          return 'Graphics'
        case 'ram':
          return 'RAM'
        case 'psu':
          return 'Power Supply'
        default:
          return type.charAt(0).toUpperCase() + type.slice(1)
      }
    },
    showAsin(){
      console.log(this.attribs.general[0])
    },
    print(index){
      return console.log(Object.values(this.settings.options)[index])
    },
  },
}
</script>

<style scoped>
@import '../../assets/css/toolkit-inverse.css';

.items-admin-page {
	width: 100%;
	max-width: 1120px;
	padding: 0 0 3rem;
	color: #cfd2da;
}

.items-admin-header {
	display: flex;
	align-items: flex-end;
	justify-content: space-between;
	gap: 1rem;
	margin-bottom: 1rem;
}

.items-admin-kicker {
	color: #1997c6;
	font-size: 12px;
	font-weight: 700;
	letter-spacing: 0.8px;
	line-height: 1;
	text-transform: uppercase;
}

.items-admin-header h1 {
	margin: 0.45rem 0 0;
	color: #cfd2da;
	font-size: 28px;
	font-weight: 500;
	letter-spacing: 0;
	line-height: 1.1;
}

.items-admin-status {
	display: inline-flex;
	align-items: center;
	gap: 0.5rem;
	min-height: 30px;
	padding: 0 0.75rem;
	border: 1px solid rgba(67, 72, 87, 0.78);
	border-radius: 6px;
	background: rgba(8, 10, 15, 0.48);
	color: #b2b3b4;
	font-size: 12px;
	font-weight: 700;
	text-transform: uppercase;
}

.items-admin-status-dot {
	width: 7px;
	height: 7px;
	border-radius: 50%;
	background: #00bc8c;
	box-shadow: 0 0 12px rgba(0, 188, 140, 0.8);
}

.items-admin-panel {
	position: relative;
	overflow: hidden;
	border: 1px solid rgba(67, 72, 87, 0.92);
	border-radius: 6px;
	background:
		linear-gradient(180deg, rgba(25, 27, 32, 0.94), rgba(13, 15, 22, 0.96)),
		rgba(25, 27, 32, 0.94);
	box-shadow:
		0 22px 70px rgba(0, 0, 0, 0.35),
		inset 0 0 0 1px rgba(255, 255, 255, 0.025);
}

.items-admin-panel--library { overflow: visible; border: 0; background: transparent; box-shadow: none; }

.items-admin-panel-topline {
	position: absolute;
	top: 0;
	right: 18px;
	left: 18px;
	height: 1px;
	background: linear-gradient(90deg, rgba(25, 151, 198, 0), rgba(25, 151, 198, 0.86), rgba(25, 151, 198, 0));
}

.items-admin-workspace {
	padding: 1.1rem 1.25rem 1.25rem;
}

.items-toolbar {
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 1rem;
	padding-bottom: 0.85rem;
	border-bottom: 1px solid rgba(67, 72, 87, 0.78);
}

.items-toolbar-nav {
	display: flex;
	flex-wrap: wrap;
	align-items: center;
	gap: 0.55rem;
}

.items-nav-button {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	gap: 0.45rem;
	min-height: 34px;
	padding: 0 0.8rem;
	border: 1px solid rgba(67, 72, 87, 0.9);
	border-radius: 6px;
	background: rgba(8, 10, 15, 0.42);
	color: #cfd2da;
	cursor: pointer;
	font-size: 13px;
	font-weight: 800;
	letter-spacing: 0.2px;
	line-height: 1;
	text-decoration: none;
	text-transform: uppercase;
	transition: background 160ms ease, border-color 160ms ease, box-shadow 160ms ease, color 160ms ease;
}

.items-nav-button .icon {
	color: #9198aa;
	font-size: 13px;
	transition: color 160ms ease;
}

.items-nav-button:hover,
.items-nav-button:focus {
	border-color: rgba(25, 151, 198, 0.78);
	background: rgba(25, 151, 198, 0.12);
	color: #ffffff;
	text-decoration: none;
}

.items-nav-button:hover .icon,
.items-nav-button:focus .icon {
	color: #1997c6;
}

.items-nav-button-primary {
	border-color: #16b4ed;
	background: linear-gradient(180deg, rgba(25, 151, 198, 0.28), rgba(12, 66, 88, 0.58));
	color: #f4f8fb;
}

.items-toolbar-meta {
	overflow: hidden;
	max-width: 40%;
	color: #9198aa;
	font-size: 12px;
	font-weight: 700;
	letter-spacing: 0.7px;
	text-overflow: ellipsis;
	text-transform: uppercase;
	white-space: nowrap;
}

@media screen and (max-width: 760px) {
	.items-admin-header,
	.items-toolbar {
		align-items: flex-start;
		flex-direction: column;
	}

	.items-toolbar-meta {
		max-width: 100%;
	}

	.items-admin-workspace {
		padding: 1rem;
	}

	.items-nav-button,
	.items-toolbar-nav {
		width: 100%;
	}
}
</style>
